import { groupBy } from "@emberly/zenith-client";
import moment from "moment/moment";
import { getCurrency } from "../../providers/StationProvider";
import { FixNumberData } from "../orders";
import { country } from "../helpers";
import CommentBuilder from "../CommentBuilder";

export function convertTo(journalLines, data, t) {
  const lines = [makeHeader(t)];
  const invoices = groupBy(journalLines, line => line.orderId);
  const { missions } = data;

  for (let orderId of invoices.keys()) {
    const invoiceLines = invoices.get(orderId);
    const initLine = invoiceLines[0];
    const missionId = initLine.missionId;
    const mission = missions.find(t => t.id === missionId);

    const cm = new CommentBuilder(t, mission, initLine);
    const missionLines = cm.build();
    
    for (let i = 0; i < missionLines.length; i++) {
      lines.push(makeTextLine(missionLines[i], mission, initLine, t));
    }

    for (let i = 0; i < invoiceLines.length; i++) {
      lines.push(makeJournalLine(invoiceLines[i], mission, t));
    }
  }

  return lines.join("\n");
}

export function makeJournalLine(journalLine, mission, t) {
  const { item, customer, reference, contactPerson } = journalLine;
  const { productGroup } = item;
  const { vatCode } = productGroup;
  const actors = mission.actors;
  
  const orderDate = moment(journalLine.orderDate);

  let line = [];

  // ImpSystem
  line.push("Assist");

  // ImpSystemRef
  line.push("");

  // InvoiceGroup
  line.push("");

  // OrderNo
  line.push(journalLine.orderNumber)

  // LineNo
  line.push(1);

  // Date
  line.push(orderDate.format("YYYYMMDD"));

  // CustomerNo
  line.push(customer.customerNumber || "");

  // InvoiceTemplate
  line.push("");

  // ReadyToInvoice
  line.push("1");

  // Project
  line.push("");

  // Object
  line.push("");

  // ObjectValue
  line.push("");

  // Posting 1
  line.push("");

  // Posting 2
  line.push("");

  // XGL
  line.push("");

  // Currency 
  line.push(getCurrency(t, journalLine.item.price.currency)); // TODO

  // Product 
  line.push(productGroup.code)

  // XLG
  line.push("");

  // Text
  line.push(Limit(item.name, 255));

  // Pricelist
  line.push("");

  // PriceGroup
  line.push("");

  // Unit
  line.push(item.unit || t("invoiceExportLines:defaultUnit"));

  // Quantity
  line.push(FixNumberData(item.quantity));

  // Cost Price
  line.push("");

  // UnitPriceImp
  line.push(FixNumberData(item.price.value));

  // Discount%
  line.push(FixNumberData(item.discount));

  // DiscountAmount
  line.push("");

  // TaxRule
  line.push(vatCode.code);

  // PrePaidToBank
  line.push("");

  // PrePaidDate
  line.push("");

  // PaymentRef
  line.push(Limit(reference, 50));

  // Xidentifier
  line.push("");

  // ExternalOrder
  line.push(journalLine.orderNumber);

  // SubledgerName
  line.push(customer.name);

  // CompanyNO
  line.push(customer.organizationNumber);

  //SubledgerGroup
  line.push("");

  // BankAccount
  line.push("");

  // PaymentTerms
  line.push("");

  // UpdateAddress
  line.push(0);

  // StreetAddressLine1
  line.push(Limit(customer.billing.address, 255));

  // StreetAddressLine2
  line.push(Limit(customer.billing.address2 || "", 255));

  // ZipCode
  line.push(customer.billing.postNumber);

  // City
  line.push(customer.billing.area);

  // State
  line.push("");

  // Country
  line.push(Limit(country(t, customer.billing.country), 255));

  // InvoiceStreetAddressLine1
  line.push(Limit(customer.billing.address, 255));

  // InvoiceStreetAddressLine2
  line.push(Limit(customer.billing.address2 || "", 255));

  // InvoiceZipCode2
  line.push(customer.billing.postNumber);

  // InvoiceCity2
  line.push(customer.billing.area);

  // InvoiceState2
  line.push("");

  // InvoiceCountry2
  line.push(customer.billing.area);

  // Phone
  line.push(customer.phoneNumber || ""); // ?

  // Email
  line.push(customer.email || "");

  // YourRef
  line.push(contactPerson?.name || "");

  // Dummy1-5
  line.push(actors?.contract?.reference || "");
  line.push("");
  line.push("");
  line.push("");
  line.push("");

  // EOL
  line.push("x");

  return line.join(";");
}


export function makeTextLine(text, mission, journalLine, t) {
  const { customer, reference, contactPerson } = journalLine;
  const orderDate = moment(journalLine.orderDate);
  const actors = mission.actors;

  let line = [];

  // ImpSystem
  line.push("Assist");

  // ImpSystemRef
  line.push("");

  // InvoiceGroup
  line.push("");

  // OrderNo
  line.push(journalLine.orderNumber)

  // LineNo
  line.push(1);

  // Date
  line.push(orderDate.format("YYYYMMDD"));

  // CustomerNo
  line.push(customer.customerNumber || "");

  // InvoiceTemplate
  line.push("");

  // ReadyToInvoice
  line.push("1");

  // Project
  line.push("");

  // Object
  line.push("");

  // ObjectValue
  line.push("");

  // Posting 1
  line.push("");

  // Posting 2
  line.push("");

  // XGL
  line.push("");

  // Currency 
  line.push(""); // TODO

  // Product 
  line.push("T")

  // XLG
  line.push("");

  // Text
  line.push(Limit(text, 255));

  // Pricelist
  line.push("");

  // PriceGroup
  line.push("");

  // Unit
  line.push("");

  // Quantity
  line.push("");

  // Cost Price
  line.push("");

  // UnitPriceImp
  line.push("");

  // Discount%
  line.push("");

  // DiscountAmount
  line.push("");

  // TaxRule
  line.push("");

  // PrePaidToBank
  line.push("");

  // PrePaidDate
  line.push("");

  // PaymentRef
  line.push(Limit(reference, 50));

  // Xidentifier
  line.push("");

  // ExternalOrder
  line.push(journalLine.orderNumber);

  // SubledgerName
  line.push(customer.name);

  // CompanyNO
  line.push(customer.organizationNumber);

  //SubledgerGroup
  line.push("");

  // BankAccount
  line.push("");

  // PaymentTerms
  line.push("");

  // UpdateAddress
  line.push(0);

  // StreetAddressLine1
  line.push(Limit(customer.billing.address, 255));

  // StreetAddressLine2
  line.push(Limit(customer.billing.address2 || "", 255));

  // ZipCode
  line.push(customer.billing.postNumber);

  // City
  line.push(customer.billing.area);

  // State
  line.push("");

  // Country
  line.push(Limit(country(t, customer.billing.country), 255));

  // InvoiceStreetAddressLine1
  line.push(Limit(customer.billing.address, 255));

  // InvoiceStreetAddressLine2
  line.push(Limit(customer.billing.address2 || "", 255));

  // InvoiceZipCode2
  line.push(customer.billing.postNumber);

  // InvoiceCity2
  line.push(customer.billing.area);

  // InvoiceState2
  line.push("");

  // InvoiceCountry2
  line.push(customer.billing.area);

  // Phone
  line.push(customer.phoneNumber || ""); // ?

  // Email
  line.push(customer.email || "");

  // YourRef
  line.push(contactPerson?.name || "");

  // Dummy1-5
  line.push(actors?.contract?.reference || "");
  line.push("");
  line.push("");
  line.push("");
  line.push("");

  // EOL
  line.push("x");

  return line.join(";");
}

function makeHeader(t) {
  const line = [
    "ImpSystem",
    "ImpSystemRef",
    "InvoiceGroup",
    "OrderNo",
    "LineNo",
    "Date",
    "CustomerNo",
    "InvoiceTemplate",
    "ReadyToInvoice",
    "Project",
    "Object",
    "ObjectValue",
    "Posting1",
    "Posting2",
    "XGL",
    "Currency",
    "Product",
    "XLG",
    "Text",
    "Pricelist",
    "PriceGroup",
    "Unit",
    "Quantity",
    "Cost Price",
    "UnitPriceImp",
    "Discount%",
    "DiscountAmount",
    "TaxRule",
    "PrePaidToBank",
    "PrePaidDate",
    "PaymentRef",
    "Xidentifier",
    "ExternalOrder",
    "SubledgerName",
    "CompanyNo",
    "SubledgerGroup",
    "BankAccount",
    "PaymentTerms",
    "UpdateAddress",
    "StreetAddressLine1",
    "StreetAddressLine2",
    "ZipCode",
    "City",
    "State",
    "Country",
    "InvoiceStreetAddress2Line1",
    "InvoiceStreetAddress2Line2",
    "InvoiceZipCode2",
    "InvoiceCity2",
    "InvoiceState2",
    "InvoiceCountry2",
    "Phone",
    "Email",
    "YourRef",
    "AgreementRef",
    "Dummy2",
    "Dummy3",
    "Dummy4",
    "Dummy5",
    "EOL",
  ];

  return line.join(";");
}

function Limit(text, limit = 25) {
  if (!text) return "";
  if (text.length <= limit) return text;
  return text.substring(0, limit - 1);
}